import { ReactNode, useCallback } from 'react';

import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getCertificateOffers } from '../api';
import {
  NonStructuredCertificateFilters,
  NonStructuredCertificatePaginatedResponse,
} from '../types';

const {
  FetchProvider: CertificateOffersProvider,
  useFetch: useCertificateOffers,
} = createFetchContext<
  NonStructuredCertificateFilters,
  NonStructuredCertificatePaginatedResponse
>();

interface Props {
  children: ReactNode;
  defaultQuery?: NonStructuredCertificateFilters;
  fetchImmediately?: boolean;
}

export const CertificateOffersLoader = ({
  children,
  defaultQuery = { page: 1, items_per_page: 12 },
  fetchImmediately = true,
}: Props) => {
  const requestFn = useCallback(
    (filters?: NonStructuredCertificateFilters) =>
      getCertificateOffers(filters ?? {}),
    [],
  );

  return (
    <CertificateOffersProvider
      request={requestFn}
      defaultQuery={defaultQuery}
      fetchImmediately={fetchImmediately}
    >
      {children}
    </CertificateOffersProvider>
  );
};

export { useCertificateOffers };
